import { Box, Divider, Heading, Text, VStack } from "native-base";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import colors from "../../../../constants/colors";
import { StateContext } from "../../../../contexts";
import routes from "../../../../routes";

const SignUpAgencyPendingPage = () => {
  const state = useContext(StateContext);

  return (
    <VStack
      maxWidth={900}
      width="100%"
      marginTop={50}
      alignSelf="center"
      backgroundColor={colors.white}
      padding={10}
      borderRadius={5}
      space={5}
      alignItems="center">
      <Helmet>
        <title>Registro - Estás a un paso de completar tu registro</title>
      </Helmet>
      <Heading color={colors.secondary} fontSize="xl" textAlign="center">
        Estás a un paso de
        <br />
        completar tu registro
      </Heading>
      <Text textAlign="center">
        Te faltan adjuntar algunos documentos, cuando los
        <br />
        tengas disponibles ingresa con
        <br />
        tu usuario y contraseña para adjuntarlos
      </Text>
      <Divider backgroundColor={colors.secondary} height="2px" />
      <Text>Este es tu usuario:</Text>
      <VStack
        space={3}
        padding={3}
        borderWidth={1}
        borderColor={colors.secondary}>
        <Heading color={colors.secondary} fontSize="md" textAlign="center">
          Correo electrónico
        </Heading>
        <Heading fontSize="md" textAlign="center">
          {state.user.email}
        </Heading>
      </VStack>
      <Link to={routes.agencyDashboard}>
        <Box
          backgroundColor={colors.primary}
          borderRadius={40}
          paddingX={100}
          paddingY={3}>
          <Text color={colors.white}>Continuar</Text>
        </Box>
      </Link>
    </VStack>
  );
};

export default SignUpAgencyPendingPage;
